import { atom } from "jotai";

export const anchorElAtom = atom<HTMLElement | null>(null);
